import SuperTokens from 'supertokens-auth-react';
import Session from 'supertokens-auth-react/recipe/session';
import EmailPassword from 'supertokens-auth-react/recipe/emailpassword';
import type { AppSettings } from '@petseo/shared';

export function initializeSuperTokens(config: AppSettings) {
  SuperTokens.init({
    appInfo: {
      appName: 'PETSEO',
      apiDomain: config.authApiDomain,
      apiBasePath: '/auth',
      websiteDomain: window.location.origin,
    },
    recipeList: [
      EmailPassword.init(),
      Session.init({
        tokenTransferMethod: 'header',
      }),
    ],
  });
}
